import React, { useState } from "react";
import UserHeader from "../../components/UserHeader";
import Footer from "../../components/Footer";
import userStore from "../../zustand/userStore";
import PricingPage from "../../features/pricing/pricing_27_04";
import TutorPricing from "./TutorPricing";
import CoachingPricing from "./CoachingPricing";
import "./allplans.css";

const TABS = [
  { key: "schools",  label: "Solutions for Schools",                  color: "#1c498d", bg: "linear-gradient(135deg,#1c498d 0%,#3a6bb5 100%)" },
  { key: "tutors",   label: "Solutions for Individual Tutors",         color: "#7c4daf", bg: "linear-gradient(135deg,#7c4daf 0%,#9c6fd6 100%)" },
  { key: "coaching", label: "Solutions for Coaching / Tuition Centres", color: "#00897b", bg: "linear-gradient(135deg,#00897b 0%,#26a69a 100%)" },
];

export default function AllPlansPage() {
  const { userData } = userStore((state) => ({ userData: state.user }));
  const [active, setActive] = useState("schools");

  const activeTab = TABS.find((t) => t.key === active);

  return (
    <div className="ap-page">
      <UserHeader />

      {/* Hero */}
      <div className="ap-hero" style={{ background: activeTab.bg }}>
        <h1 className="ap-hero-title">Pricing Plans</h1>
        <p className="ap-hero-sub">Transparent pricing for every kind of educator</p>
      </div>

      {/* Tab strip */}
      <div className="ap-tabs">
        {TABS.map((tab) => (
          <button
            key={tab.key}
            type="button"
            className={`ap-tab${active === tab.key ? " ap-tab--active" : ""}`}
            style={active === tab.key ? { background: tab.color, borderColor: tab.color } : {}}
            onClick={() => setActive(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Embedded pricing pages — one shown at a time */}
      <div style={{ display: active === "schools" ? "block" : "none" }}>
        <PricingPage embedded />
      </div>
      <div style={{ display: active === "tutors" ? "block" : "none" }}>
        <TutorPricing embedded />
      </div>
      <div style={{ display: active === "coaching" ? "block" : "none" }}>
        <CoachingPricing embedded />
      </div>

      <Footer userData={userData} />
    </div>
  );
}
